import { createStore } from 'redux';

// REDUX PERSIST
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// ROOT REDUCER
import rootReducer from './reducers/index';

const migrations = {  
  0: (state) => {    
      return {
        ...state.data,
        storedData: {
          storedData: {
            totalSharesGraph: [],
            totalShares: [],
            totalSalesGraph: [],
            totalSales: [],
            salesDrivers: {
              plotData: [],
              salesTrendTables: [],
              dateRange: [],
            },
            marketShare: {
              marketSalesTable: {
                top5SalesTrendTables: [],
                top5SalesPlotData: [],
                closest5SalesPlotData: [],
                closest5SalesTrendTables: []
              },
              marketSharesTable: {
                top5SharesTrendTables: [],
                top5SharesPlotData: [],
                closest5SharesPlotData: [],
                closest5SharesTrendTables: [],
              },
            },
            topPerformers: []
          }
        }
      }
  }
}

// REDUX PERSIST CONFIGS
const persistConfig = {
  key: 'persistedStorage',
  version: 0,
  storage,
  migrate: createMigrate(migrations, { debug: true }),
  whitelist: ['data'], // set data reducer to local storage
};



const modifiedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(modifiedReducer);
const persistor = persistStore(store);

export { store, persistor };
